'use client';
import React from 'react';

import type { AuthContainerV2Props } from '../types';
import { PageSurface } from '../surfaces/PageSurface';
import { PaywallSurface } from '../surfaces/PaywallSurface';
import { RegwallSurface } from '../surfaces/RegwallSurface';

/** Surface dispatcher. Each surface owns its own layout and post-success behavior. */
export const AuthContainerV2: React.FC<AuthContainerV2Props> = props => {
  switch (props.surface) {
    case 'page':
      return <PageSurface {...props} />;
    case 'paywall':
      return <PaywallSurface {...props} />;
    case 'regwall':
      return <RegwallSurface {...props} />;
    default: {
      const _exhaustive: never = props.surface;
      if (process.env.NODE_ENV !== 'production') {
        throw new Error(`AuthContainerV2: unknown surface "${_exhaustive}"`);
      }
      return <PageSurface {...props} surface="page" />;
    }
  }
};

AuthContainerV2.displayName = 'AuthContainerV2';
